module.exports = __webpack_public_path__ + "img/flow-hover.2c8ddce2.png";